export default __webpack_public_path__ + "images/77f8672519bdadcc017cca263dc30a56-new_age.jpg";